<template>
  <div class="container">
    <img class="button-enter" src="../assets/img/title_start_btn.png" alt="start" @click="moveToEntrance">
    <snowf :amount="5" :size="12" :image="particle1"></snowf>
    <snowf :amount="5" :size="12" :swing="2" :image="particle2"></snowf>
  </div>
</template>

<script>
  import Snowf from "vue-snowf";

  export default {
    name: "myTitle",
    components: {
      Snowf
    },
    data() {
      return {
        particle1: require("../assets/img/sakura1.png"),
        particle2: require("../assets/img/sakura2.png")
      }
    },
    methods: {
      moveToEntrance() {
        this.$emit("play-sound", "audio/vrschool_se_title.mp3");
        this.$emit("play-sound", "audio/vrschool_wc_voice_002.mp3");
        this.$router.push("/entrance");
      }
    },
    mounted() {
      setTimeout(() => {
        this.$emit("start");
      }, 500);
    }
  }
</script>

<style scoped>

  .container {
    background: url("../assets/img/title_bg.png") no-repeat fixed center;
    background-size: contain;
  }

  .button-enter {
    position: absolute;
    z-index: 2;
    width: 22.5%;
    height: 14%;
    top: 73%;
    left: 39%;
    cursor: pointer;
  }

</style>